export default {
  enabledRules(state, enabledRules) {
    state.enabledRules = enabledRules;
  },
  disabledRules(state, disabledRules) {
    state.disabledRules = disabledRules;
  },
  addRule(state, rule) {
    state.enabledRules.push(rule);
  },
  disableRule(state, orderIndex) {
    state.enabledRules = state.enabledRules.filter((el) => el.orderIndex !== orderIndex);
  },
  enableRule(state, orderIndex) {
    state.enabledRules.push(state.disabledRules.find((el) => el.orderIndex === orderIndex));
    state.disabledRules = state.disabledRules.filter((el) => el.orderIndex !== orderIndex);
  },
  cooldown(state, cooldown) {
    state.cooldown = cooldown;
  },
  cooldownTypeId(state, cooldownTypeId) {
    state.cooldownTypeId = cooldownTypeId;
  },
  dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct(
    state,
    dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct
  ) {
    state.dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct =
      dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct;
  },
  dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId(
    state,
    dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId
  ) {
    state.dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId =
      dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId;
  },
  numberOfRulesSentAfterAction(state, numberOfRulesSentAfterAction) {
    state.numberOfRulesSentAfterAction = numberOfRulesSentAfterAction;
  },
  numberOfRulesSentAfterActionId(state, numberOfRulesSentAfterActionId) {
    state.numberOfRulesSentAfterActionId = numberOfRulesSentAfterActionId;
  },
  deletedPagesCount(state, deletedPagesCount) {
    state.deletedPagesCount = deletedPagesCount;
  },
  trackerProductCategories(state, trackerProductCategories) {
    state.trackerProductCategories = trackerProductCategories;
  },
  loading(state, isLoading) {
    state.isLoading = isLoading;
  },
  error(state, hasError) {
    state.hasError = hasError;
  },
  editRule(state, { rule, index }) {
    state.enabledRules[index] = rule;
  },
};
